var _circle, _g, _circle2, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmitSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 162,
    viewBox: "0 0 146 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5832,
    cy: 71.0402,
    r: 71.0402,
    fill: "#E0EBF4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3246_13798)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.899,
    cy: 132.954,
    r: 21.724,
    fill: "#407DBB"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9136,
    cy: 19.7144,
    r: 8.56208,
    fill: "#407DBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.546 41.2734C92.7761 41.2734 98.6369 47.1342 98.6369 54.3643C98.6369 61.5945 92.7761 67.4553 85.546 67.4553C78.3159 67.4553 72.4551 61.5945 72.4551 54.3643C72.4551 47.1342 78.3159 41.2734 85.546 41.2734ZM91.1973 50.1857C91.0548 50.0432 90.8647 49.9584 90.6635 49.9474C90.4623 49.9364 90.2641 50.0001 90.1069 50.1262L90.0401 50.1857L83.4187 56.8071L81.0519 54.4403C80.9039 54.2923 80.7049 54.2066 80.4957 54.2008C80.2865 54.1951 80.083 54.2697 79.9272 54.4094C79.7713 54.5491 79.6749 54.7432 79.6578 54.9517C79.6407 55.1603 79.7041 55.3675 79.8351 55.5307L79.8946 55.5975L82.8401 58.543C82.9826 58.6854 83.1727 58.7703 83.3739 58.7813C83.5752 58.7923 83.7734 58.7286 83.9306 58.6025L83.9973 58.543L91.1973 51.343C91.2733 51.267 91.3336 51.1768 91.3747 51.0775C91.4159 50.9782 91.437 50.8718 91.437 50.7643C91.437 50.6569 91.4159 50.5505 91.3747 50.4512C91.3336 50.3519 91.2733 50.2617 91.1973 50.1857Z",
    fill: "#407DBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3 47.5734C45.3 46.9469 45.5489 46.346 45.9919 45.9029C46.435 45.4598 47.0358 45.2109 47.6623 45.2109L67.8833 45.2109C68.7984 43.7624 69.8978 42.4388 71.1538 41.2734L47.6623 41.2734C45.9916 41.2734 44.3893 41.9372 43.208 43.1187C42.0266 44.3001 41.3629 45.9026 41.3629 47.5734L41.3629 79.6116C41.363 81.2824 42.0267 82.8848 43.2081 84.0662L61.5656 102.425C61.7021 102.562 61.8543 102.677 62.0039 102.793L62.1509 102.906C62.9193 103.522 63.8221 103.948 64.7861 104.15C65.1931 104.232 65.6072 104.273 66.0224 104.273H87.4272C88.2546 104.273 89.074 104.11 89.8385 103.794C90.6029 103.477 91.2975 103.013 91.8824 102.427C92.4674 101.842 92.9314 101.147 93.2478 100.383C93.5642 99.6179 93.7269 98.7984 93.7266 97.9708V73.1252C92.4747 73.7877 91.1546 74.3123 89.7894 74.6897V97.9708C89.7894 99.2754 88.7291 100.336 87.4272 100.336H67.6104V83.2734C67.6104 81.8811 67.0573 80.5457 66.0728 79.5611C65.0884 78.5766 63.7531 78.0234 62.3609 78.0234L45.3 78.0261L45.3 47.5734ZM63.6733 98.9631L46.6702 81.9636L62.3609 81.9609C62.5333 81.9606 62.7041 81.9943 62.8635 82.0601C63.0229 82.126 63.1677 82.2226 63.2896 82.3446C63.4116 82.4665 63.5082 82.6114 63.5741 82.7708C63.6399 82.9302 63.6736 83.101 63.6733 83.2734V98.9631Z",
    fill: "#407DBB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3246_13798",
    x: 96.1748,
    y: 111.23,
    width: 49.4482,
    height: 50.4473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.490196 0 0 0 0 0.733333 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3246_13798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3246_13798",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitSummary);
export default __webpack_public_path__ + "static/media/submit_summary.dbf2e57704fb5c511197b543a9d8f180.svg";
export { ForwardRef as ReactComponent };